import type {
  ChecklistItemRequest,
  ChecklistItemResponse,
} from '../types/checklist';
import { api } from './api';

export async function updateChecklist(
  taxCaseId: string,
  items: ChecklistItemRequest[],
): Promise<ChecklistItemResponse[]> {
  const { data } = await api.put<ChecklistItemResponse[]>(
    `/checklists/tax-case/${taxCaseId}`,
    { items },
  );
  return data;
}

export async function getChecklist(
  taxCaseId: string,
): Promise<ChecklistItemResponse[]> {
  const { data } = await api.get<ChecklistItemResponse[]>(
    `/checklists/tax-case/${taxCaseId}`,
  );
  return data;
}

export async function markItemCompleted(
  itemId: string,
  documentId: string,
): Promise<ChecklistItemResponse> {
  const { data } = await api.patch<ChecklistItemResponse>(
    `/checklists/items/${itemId}/complete`,
    null,
    { params: { documentId } },
  );
  return data;
}

export async function deleteChecklistItem(itemId: string): Promise<void> {
  await api.delete(`/checklists/items/${itemId}`);
}
